import * as zod from 'zod';

export const Recipe = zod
  .object({
    id: zod.string(),
    equipment_kind: zod.string().nullable(),
    step_kind: zod.string().nullable(),
    recipe_name: zod.string(),
    settings: zod.record(zod.any()),
  })
  .strip();

export type Recipe = zod.infer<typeof Recipe>;
